import { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useLocalSearchParams, useNavigation, useRouter } from 'expo-router';
import { Query } from '@/utils/react-query/Queries';
import { Mutation } from '@/utils/react-query/Mutations';
import ProfileViewBuilder from '@/components/ProfileViews/ProfileViewBuilder';
import EmptyListPlaceholder from '@/components/General/EmptyListPlaceholder';
import PageTitle from '@/components/General/PageTitle';

export default function ProfileViewScreen() {
    const router = useRouter();
    const navigation = useNavigation();
    const { viewID } = useLocalSearchParams();

    const { data: loggedInUser, isLoading: userLoading } = Query.people.loggedInUser();
    const { data: view, isLoading: viewLoading, isFetching } = Query.profileViews.byId({ id: viewID });
    const save = Mutation.profileViews.save();
    const canManage = loggedInUser?.can?.('Manage Profile Views');

    useEffect(() => {
        if (view?.name) {
            navigation.setOptions({
                headerTitle: () => <PageTitle title={view.name} subtitle="Profile View" />,
            });
        }
    }, [navigation, view?.name]);

    if (!viewID) {
        router.canGoBack() ? router.back() : router.replace('/');
        return null;
    }

    if (userLoading || (!view?.id && isFetching)) {
        return <View style={styles.center}><ActivityIndicator /></View>;
    }

    if (!canManage) {
        return (
            <View style={styles.center} testID="profile-view-edit-requires-permission">
                <EmptyListPlaceholder noLottie spacing={48} message="You don't have permission to manage profile views." />
            </View>
        );
    }

    if (!view?.id && !viewLoading) {
        return <EmptyListPlaceholder type="404" message="Profile view not found" />;
    }

    const handleSubmit = ({ name, config }) => {
        save.mutate({ id: view.id, name, config });
    };

    if (!view?.id) return null;

    return (
        <View style={styles.container} testID="profile-view-edit-screen">
            <ProfileViewBuilder
                view={view}
                saving={save.isPending}
                onSubmit={handleSubmit}
                onCancel={() => router.back()}
            />
        </View>
    );
}

const styles = StyleSheet.create(({ colors }) => ({
    container: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    center: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
}));
